
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class TabNavItem extends Vue {
    @Prop({ default: false }) active!: boolean;

    get classes() {
        return {
            active: this.active,
        };
    }
}
